//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableRow from "~/components/linses/main-page/TableRow.vue";
import CustomSelect from '~/components/common/CustomSelect.vue';
import LensesSliderMobileCard from "~/components/linses/LensesSliderMobileCard.vue";
import LenesesDisclaimer from "~/components/linses/LensesDisclaimer.vue";

export default {
  name: 'LinsesOffers',
  components: {
    TableRow,
    CustomSelect,
    LensesSliderMobileCard,
    LenesesDisclaimer
  },

  data() {
    return {
      linsesLabelsType: [],
      activeType: {},

      swiperMobileParamsMain: {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
          el: ".linses-offers-mobile-slider-main-pagination",
          bulletElement: "div",
          dynamicMainBullets: 0,
        },
        on: {
          slideChange: this.eventSlideMobileChangeMain.bind(this)
        }
      },
      swiperMobileParamsMainActiveSlide: 1,

      swiperMobileParamsOther: {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
          el: ".linses-offers-mobile-slider-other-pagination",
          bulletElement: "div",
          dynamicMainBullets: 0,
        },
        on: {
          slideChange: this.eventSlideMobileChangeOther.bind(this)
        }
      },
      swiperMobileParamsOtherActiveSlide: 1,
    }
  },

  props: {
    linsesOffer: {
      type: Array,
      default: () => []
    },
    isOdv: {
      type: Boolean,
      default: false,
    },
    lensTypeTexts: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    offerText() {
      return this.lensTypeTexts.find(t => t?.lens_type === this.activeType.id)?.text || '';
    },
    name() {
      return this?.competitors?.name || "";
    },

    tableParams() {
      const active = this.linsesOffer.find(t => t?.lens_type?.id === this.activeType.id);

      return {
        self: active?.self || [],
        itemsLenes: active?.lens_type || [],
        itemsCompetitors: active?.competitors || [],
        lenses: active?.lenses || [],
      }
    },


    mobileSliderMain: function () {
      if (this.isOdv) {
        return this.tableParams?.self || []
      }

      return (this.tableParams?.lenses || []).map((t) => {
        return {
          ...(t?.lense || {}),
          ...(t?.reflections || {}),
        }
      })
    },
    mobileSliderOther: function () {
      if (this.isOdv) {
        return (this.tableParams?.itemsCompetitors || []).map((t) => {
          return {
            ...(t?.competitor || {}),
            ...(t?.reflections || {}),
          }
        })
      }
      let _list = [
        ...(this.tableParams?.itemsCompetitors || []),
      ].map((t) => {
        return {
          ...(t?.competitor || {}),
          ...(t?.reflections || {}),
        }
      });
      if (this.tableParams?.self) {
        _list.unshift(this.tableParams?.self);
      }

      return _list
    },
  },
  mounted() {
    this.initLinsesList();
  },

  methods: {
    initLinsesList() {
      this.linsesLabelsType = this.linsesOffer.map(t => {
        return t.lens_type
      });

      this.activeType = this.linsesLabelsType?.[0] || null;
    },

    changeCurrentLinseType(active) {
      this.activeType = active;
      this.resetSliderActive();
    },

    valueFormater(params) {
      return Object.entries(params)
        .filter(([key, value]) => key.includes('reflection_'))
        .map(([key, value]) => ({[key.replace('reflection_', '')]: value}));
    },

    resetSliderActive: function () {
      this.$refs.refSwiperLenseMobileParamsLeft?.swiper.slideTo(0);
      this.$refs.refSwiperLenseMobileParamsRight?.swiper.slideTo(0);
    },
    eventSlideMobileChangeMain: function () {
      this.swiperMobileParamsMainActiveSlide = (this.$refs.refSwiperLenseMobileParamsLeft?.swiper?.activeIndex || 0) + 1;
    },
    eventSlideMobileChangeOther: function () {
      this.swiperMobileParamsOtherActiveSlide = (this.$refs.refSwiperLenseMobileParamsRight?.swiper?.activeIndex || 0) + 1;
    },
  },
}
